export const C = {
  navy:'#0D3B5E', navyD:'#082B47', navyM:'#1A5276', navyL:'#EBF4FF',
  gold:'#E8930A', goldL:'#FEF3DC', goldB:'#F5A623',
  green:'#15803D', greenL:'#DCFCE7', greenB:'#16A34A',
  sky:'#0369A1', skyL:'#DBEAFE', skyB:'#0284C7',
  purple:'#6D28D9', purpleL:'#EDE9FE', purpleB:'#7C3AED',
  teal:'#0D9488', tealL:'#CCFBF1', tealB:'#5EEAD4',
  orange:'#EA580C', orangeL:'#FFF7ED',
  red:'#B91C1C', redL:'#FEF2F2', redB:'#DC2626', redBord:'#FECACA',
  border:'#E5E7EB', borderL:'#F3F4F6',
  bg:'#F4F6F9', white:'#FFFFFF',
  t1:'#111827', t2:'#374151', t3:'#6B7280', t4:'#9CA3AF',
};

export const fmtAmt = n =>
  (n != null && n !== '' && n !== 0) ? '₹' + Number(n).toLocaleString('en-IN') : '₹0';

export const now     = new Date();
export const lmDate  = new Date(now.getFullYear(), now.getMonth() - 1, 1);
export const lmName  = lmDate.toLocaleString('en-IN', { month: 'long', year: 'numeric' });
export const curYear  = now.getFullYear();
export const curMonth = now.getMonth() + 1;

export const YEARS = Array.from({ length: 5 }, (_, i) => String(curYear - i));
export const MONTHS = [
  { v:'1',  l:'January'   }, { v:'2',  l:'February'  }, { v:'3',  l:'March'     },
  { v:'4',  l:'April'     }, { v:'5',  l:'May'        }, { v:'6',  l:'June'      },
  { v:'7',  l:'July'      }, { v:'8',  l:'August'     }, { v:'9',  l:'September' },
  { v:'10', l:'October'   }, { v:'11', l:'November'   }, { v:'12', l:'December'  },
];

export const STAGE_CFG = {
  DISBURSEMENT: { bg:'#DCFCE7', color:'#16A34A' },
  PDD:          { bg:'#EBF4FF', color:'#0D3B5E' },
  REVENUE:      { bg:'#CCFBF1', color:'#5EEAD4' },
  CLOSED:       { bg:'#F3F4F6', color:'#6B7280' },
  LOGIN:        { bg:'#EDE9FE', color:'#7C3AED' },
  SANCTION:     { bg:'#DBEAFE', color:'#0284C7' },
  FOLLOW_UP:    { bg:'#FEF3DC', color:'#E8930A' },
};
